import loadable from '@loadable/component';

const InfoPage = loadable(() => import('./InfoPage'));

export { InfoPage };
export { InfoType } from './InfoType';
